"use strict";

var $ = require("jquery");
var TimumApi = require("./timum_api");

var ConfigDep = require("./config");
var UtilsDep = require("./utils");
var RenderDep = require("./render");

// Main library
function Initialize() {
    // SDK instance
    var sdk = new TimumApi();
    var utils = new UtilsDep();
    var config = new ConfigDep({ utils: utils });
    var render = new RenderDep({ config: config, utils: utils, sdk: sdk });
    var getConfig = config.getConfig;

    // Initilization method
    var init = function (suppliedConfig) {
        // Make sure that debug flag is checked early
        var localConfig = config.setDefaults(suppliedConfig || {});
        config.update(localConfig);
        utils.logDebug(["Version:", getVersion()], config);
        utils.logDebug(["Supplied config:", suppliedConfig], config);

        // Set rootTarget to the target element and clean before child nodes before continuing
        try {
            render.prepareDOM(suppliedConfig || {});
        } catch (e) {
            utils.logError(e);
            return this;
        }

        // Check whether a config is supplied
        if (!utils.doesConfigExist(suppliedConfig)) {
            render.triggerError(
                "No configuration was supplied. Please supply a config object upon library initialization"
            );
            return this;
        }

        return startWithConfig(suppliedConfig);
    };

    // Setup the timum SDK with correct config
    var configureSdk = function () {
        sdk.configure(getConfig());
    };

    // Parse the config and start rendering
    var startWithConfig = function (suppliedConfig) {
        // Handle config and defaults
        try {
            config.parseAndUpdate(suppliedConfig);
        } catch (e) {
            render.triggerError(e);
            return this;
        }

        utils.logDebug(["Final config:", getConfig()], config);

        try {
            return startRender();
        } catch (e) {
            render.triggerError(e);
            return this;
        }
    };

    // Render method
    var startRender = function () {
        utils.doCallback("renderStarted", config);

        // Setup timum SDK config
        configureSdk();

        // Start by guessing customer timezone
        if (getConfig().ui.timezone) {
            render.setCustomerTimezone(getConfig().ui.timezone);
        } else {
            render.guessCustomerTimezone();
        }

        // Get products and dispaly dialog
        render.renderProductSelection();

        // Initialize FullCalendar
        render.initializeCalendar();

        // Get availability through timum SDK
        render.getAvailability();

        // Show image avatar if set
        if (getConfig().ui.avatar) {
            render.renderAvatarImage();
        }

        // Print out display name
        if (getConfig().ui.display_name) {
            render.renderDisplayName();
        }

        // Show the footer with timezone helper and TK credits
        render.renderFooter();

        utils.doCallback("renderCompleted", config);

        return this;
    };

    // Get library version
    var getVersion = function () {
        return VERSION;
    };

    var destroy = function () {
        render.destroyFullCalendar();
        render.prepareDOM({});
        config.update({});
        return this;
    };

    // Expose methods
    return {
        setConfig: config.parseAndUpdate,
        getConfig: getConfig,
        getVersion: getVersion,
        render: startRender,
        init: init,
        destroy: destroy,
        fullCalendar: render.fullCalendar,
        TimumApi: sdk
    };
}

module.exports = Initialize;
